import { jsxs as x, jsx as c } from "react/jsx-runtime";
import { useRef as S, useEffect as v } from "react";
import { SearchNavigationEvent as r } from "../../types.js";
import { SearchBarContentWrapper as y, SearchBarBackButton as C, SearchBarInputContainer as k, Input as L } from "./style.js";
import { useSearchBarContext as I } from "../../context.js";
import { ArrowLeft as j, MagnifyingGlass as q } from "@pelando/fontawesome/icons";
const i = {
  backButtonLabel: "Voltar",
  inputLabel: "Buscar",
  inputPlaceholder: "Busque por promoções ou lojas"
};
function A({
  backButtonLabel: h = i.backButtonLabel,
  inputLabel: s = i.inputLabel,
  inputPlaceholder: f = i.inputPlaceholder
}) {
  const { commands: t, isInputOpen: n, inputRef: a, defaultValue: l } = I(), u = S(null), p = () => {
    t({
      type: r.Open,
      payload: void 0
    });
  }, d = (e) => {
    var o;
    e && e.preventDefault(), n || p(), t({
      type: r.Submit,
      payload: { value: (o = a == null ? void 0 : a.current) == null ? void 0 : o.value }
    });
  }, b = (e) => {
    t({
      type: r.Change,
      payload: { value: e.target.value }
    });
  }, m = (e) => {
    const o = e ? r.Focus : r.Blur;
    t({
      type: o,
      payload: void 0
    });
  }, g = () => {
    t({
      type: r.Back,
      payload: void 0
    });
  }, B = () => {
    var e, o;
    if (!((e = u.current) != null && e.requestSubmit)) {
      d(null);
      return;
    }
    (o = u.current) == null || o.requestSubmit();
  };
  return v(() => {
    a != null && a.current && (a.current.value = l || "");
  }, [l]), /* @__PURE__ */ x(
    y,
    {
      role: "combobox",
      "aria-expanded": n,
      "aria-controls": "suggestions",
      "aria-haspopup": "listbox",
      children: [
        n && /* @__PURE__ */ c(
          C,
          {
            role: "button",
            "aria-label": h,
            icon: j,
            onClick: g
          }
        ),
        /* @__PURE__ */ c(
          k,
          {
            ref: u,
            onSubmit: d,
            role: "combobox",
            "aria-expanded": n,
            "aria-controls": "suggestions",
            "aria-haspopup": "listbox",
            children: /* @__PURE__ */ c(
              L,
              {
                id: "suggestions",
                autoComplete: "off",
                placeholder: f,
                innerRef: a,
                onChange: b,
                invalid: !1,
                "aria-autocomplete": "list",
                "aria-label": s,
                onFocus: () => m(!0),
                onBlur: () => m(!1),
                icon: q,
                iconLabel: s,
                onIconClick: n ? B : p,
                maxLength: 127,
                defaultValue: l,
                rounded: !0
              }
            )
          }
        )
      ]
    }
  );
}
export {
  A as SearchBox,
  i as defaultTexts
};
